var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarehouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0069 3.77169L4.00691 9.10502C3.36644 9.67432 3 10.4903 3 11.3472V21.2501H2C1.58579 21.2501 1.25 21.5858 1.25 22.0001C1.25 22.4143 1.58579 22.7501 2 22.7501H22C22.4142 22.7501 22.75 22.4143 22.75 22.0001C22.75 21.5858 22.4142 21.2501 22 21.2501H21V11.3472C21 10.4903 20.6336 9.67432 19.9931 9.10502L13.9931 3.77169C12.8564 2.76133 11.1436 2.76133 10.0069 3.77169ZM10 8.25005C9.58579 8.25005 9.25 8.58584 9.25 9.00005C9.25 9.41426 9.58579 9.75005 10 9.75005H14C14.4142 9.75005 14.75 9.41426 14.75 9.00005C14.75 8.58584 14.4142 8.25005 14 8.25005H10ZM14.052 11.25C14.9505 11.25 15.6997 11.25 16.2945 11.33C16.9223 11.4144 17.4891 11.6 17.9445 12.0555C18.4 12.511 18.5857 13.0778 18.6701 13.7056C18.7501 14.3004 18.75 15.0496 18.75 15.9481L18.75 21.2501H17.25H6.75H5.25L5.25 15.9481C5.24997 15.0496 5.24994 14.3004 5.32991 13.7056C5.41432 13.0778 5.59999 12.511 6.05546 12.0555C6.51093 11.6 7.07773 11.4144 7.70552 11.33C8.3003 11.25 9.04952 11.25 9.948 11.25H14.052Z",
    fill: "#D4D4DD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M14.052 11.25H9.948H9.94797C9.04952 11.25 8.30029 11.2499 7.70552 11.3299C7.07773 11.4143 6.51093 11.6 6.05546 12.0555C5.59999 12.5109 5.41432 13.0777 5.32991 13.7055C5.24995 14.3003 5.24997 15.0495 5.25 15.9479V15.9479L5.25 21.25H18.75L18.75 15.948C18.75 15.0496 18.7501 14.3003 18.6701 13.7055C18.5857 13.0777 18.4 12.5109 17.9445 12.0555C17.4891 11.6 16.9223 11.4143 16.2945 11.3299C15.6997 11.2499 14.9505 11.25 14.052 11.25H14.052Z",
    fill: "#D4D4DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 14.75C8.58579 14.75 8.25 15.0858 8.25 15.5C8.25 15.9142 8.58579 16.25 9 16.25H15C15.4142 16.25 15.75 15.9142 15.75 15.5C15.75 15.0858 15.4142 14.75 15 14.75H9Z",
    fill: "#D4D4DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 17.75C8.58579 17.75 8.25 18.0858 8.25 18.5C8.25 18.9142 8.58579 19.25 9 19.25H15C15.4142 19.25 15.75 18.9142 15.75 18.5C15.75 18.0858 15.4142 17.75 15 17.75H9Z",
    fill: "#D4D4DD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/warehouse.df9eea43a45e047ec0e5a1f8d00beef8.svg";
export { ForwardRef as ReactComponent };